import log from "loglevel";

// Set the default log level based on the environment
const isProduction = process.env.NODE_ENV === "production";
log.setLevel(isProduction ? "warn" : "debug");

export default log;
